module.exports = __webpack_public_path__ + "img/4G摄像头.c1904807.jpg";